import $ from "jquery";

$( document ).on( "click", "ul.products li.product", function ( e ) {
	if ( $( e.target ).is( "a" ) || $( e.target ).is( "[class^=\"product-stock\"]" ) ) {
		return;
	}

	e.preventDefault();

	const url = $( this ).find( ".woocommerce-loop-product__link" ).data( "url" );

	if ( url !== undefined ) {
		location.href = url;
	}

	return false;
} );

document.addEventListener( "facetwp-loaded", () => {
	const $productList = $( ".woocommerce ul.products:not(.product-overview-type-list)" );

	if ( $productList.length ) {
		new Foundation.Equalizer( $productList );
	}
} );